import {StyledAgendaPageWrapper} from '@/features/agenda/components/agenda-page-wrapper/style'
import {ReactNode} from 'react'

export const AgendaPageWrapper = ({children}: {children: ReactNode}) => {
    return <StyledAgendaPageWrapper>{children}</StyledAgendaPageWrapper>
}
